import React from "react";
import ImageStepper from "@/components/ImageStepper";

import { IMAGES } from "@/lib/constants";
import { Stack } from "@mui/material";

const AadharKYCCard = React.memo(({ isPanInstruction = false }) => {
  const AADHAR_VERIFICATION = [
    {
      image: IMAGES.adharDetails,
      label: isPanInstruction
        ? "(PAN + DOB) Verification"
        : "Enter Aadhaar (12 digits)",
    },
    {
      image: IMAGES.adharNumberVerification,
      label: "DigiLocker Verification",
      hidden: isPanInstruction,
    },
    {
      image: IMAGES.otpvarification,
      label: "OTP verification",
      hidden: !isPanInstruction,
    },
    {
      image: IMAGES.faceVerification,
      label: "Face verification",
      hidden: isPanInstruction,
    },
  ];

  return (
    <Stack mt={4} gap={2}>
      <ImageStepper schema={AADHAR_VERIFICATION} />
    </Stack>
  );
});

export default AadharKYCCard;
